import { env } from '@bb/env';
import posthog from 'posthog-js';

posthog.init(env.NEXT_PUBLIC_POSTHOG_KEY, {
  api_host: '/ingest', // ingest is a rewrite in next.config.ts
  ui_host: 'https://us.posthog.com',
  person_profiles: 'identified_only',
  capture_pageview: false,
  capture_pageleave: true,
});
